import { ConfirmDialog } from "../../ui";

type DeleteLocationDialogProps = {
  locationName: string;
  isOpen: boolean;
  onDelete: () => Promise<void>;
  onClose: (update?: boolean) => void;
};

const DeleteLocationDialog = (props: DeleteLocationDialogProps) => (
  <ConfirmDialog
    open={props.isOpen}
    // Error handling is done in the parent component; a failed delete keeps the dialog open
    onConfirm={props.onDelete}
    onClose={(confirmed) => props.onClose(confirmed ? true : undefined)}
    title="Delete Location"
    confirmLabel="Delete"
    message={
      <>
        <p>
          Are you sure you want to delete <strong>"{props.locationName}"</strong>?
        </p>
        <p>Tournaments using this location will have their location cleared.</p>
      </>
    }
  />
);

export default DeleteLocationDialog;
